import { useEffect, useState } from "react";



import { useNavigate } from "react-router-dom";  

const rows = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"];
const seatsPerRow = 10;

const generateRandomUnavailableSeats = () => {
  const allSeats = [];
  for (let r of rows) {
    for (let i = 1; i <= seatsPerRow; i++) {
      allSeats.push(`${r}${i}`);
    }
  }
  const shuffled = allSeats.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, 8);
};

const SeatMap = () => {
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [unavailableSeats, setUnavailableSeats] = useState([]);

const navigate = useNavigate()
  useEffect(() => {
    setUnavailableSeats(generateRandomUnavailableSeats());
  }, []);

  const toggleSeat = (row, seat) => {
    const seatId = `${row}${seat}`;
    if (unavailableSeats.includes(seatId)) return;
    setSelectedSeats((prev) =>
      prev.includes(seatId)
        ? prev.filter((s) => s !== seatId)
        : [...prev, seatId]
    );
  };

  const getSeatImage = (seatId) => {
    if (selectedSeats.includes(seatId)) return "/redseat.png";
    return "/greyseat.png";
  };

  return (
    <div className="flex flex-col items-center px-4 py-8">
      <h2 className="text-2xl font-bold mb-6">Select Your Seat</h2>

      {/* Legend */}
      <div className="flex gap-6 mb-8">
        <div className="flex items-center gap-2">
          <img src="/greyseat.png" alt="Available" className="w-5 h-5" />
          <span className="text-sm">Available</span>
        </div>
        <div className="flex items-center gap-2">
          <img src="/seat.png" alt="Unavailable" className="w-5 h-5" />
          <span className="text-sm">Unavailable</span>
        </div>
        <div className="flex items-center gap-2">
          <img src="/redseat.png" alt="Selected" className="w-5 h-5" />
          <span className="text-sm">Selected</span>
        </div>
      </div>

      {/* Screen */}
      <div className="w-full max-w-2xl mb-8">
        <img src="/line.png" className="h-[30px] md:translate-x-40" />
        <div className="border-gray-400 w-full mb-2 rounded-full" />
        <p className="text-center font-medium">SCREEN</p>
      </div>

      {/* Seat rows */}
      <div className="flex flex-col gap-2 items-center mb-12">
        {rows.map((row) => (
          <div key={row} className="flex items-center gap-1">
            <span className="w-5 text-right mr-2 font-semibold">{row}</span>
            {Array.from({ length: seatsPerRow }).map((_, i) => {
              const seatNum = i + 1;
              const seatId = `${row}${seatNum}`;
              const isUnavailable = unavailableSeats.includes(seatId);

              return (
                <div
                  key={seatId}
                  onClick={() => toggleSeat(row, seatNum)}
                  className={`cursor-pointer ${
                    isUnavailable ? "pointer-events-none opacity-30" : ""
                  }`}
                  title={seatId}
                >
                  <img
                    src={getSeatImage(seatId)}
                    alt={`Seat ${seatId}`}
                    className="w-6 h-6"
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Proceed Button */}
      <button onClick={()=>navigate('/payment')}
        className={`px-8 py-2 font-bold text-black rounded-md ${
          selectedSeats.length > 0
            ? "bg-red-500 text-white"
            : "bg-gray-300 text-black cursor-not-allowed"
        }`}
        disabled={selectedSeats.length === 0}
      >
        PROCEED
      </button>
    </div>
  );
};

export default SeatMap;
